import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
import { Image } from '@design-system/image';
import { useTheme } from '@design-system/theme';
export const Preview = ({ image, name, onClick, onError }) => {
    const theme = useTheme();
    const renderContent = () => {
        if (image) {
            return _jsx(Image, { alt: "", onError: onError, src: image });
        }
        return (_jsxs(FileNameWrapper, { children: [_jsx(FontAwesomeIcon, { color: theme.colors.primary, height: "64px", iconName: "file-lines", iconType: CATEGORIES.DUOTONE }), _jsx(FileName, { children: _jsx(Dotdotdot, { clamp: 2, children: name }) })] }));
    };
    if (onClick) {
        return (_jsx(WrapperPreview, { "aria-label": __('Change image'), onClick: onClick, onKeyDown: onEnterOrSpacePress(onClick), role: "button", tabIndex: 0, children: renderContent() }));
    }
    return _jsx(WrapperPreview, { children: renderContent() });
};
const WrapperPreview = styled(Box).attrs({
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  cursor: ${(props) => props.onClick && 'pointer'};
  overflow: hidden;
  position: relative;
  user-select: none;

  img {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: inherit;
    height: 100%;
    object-fit: cover;
  }
`;
const FileNameWrapper = styled(Box).attrs({
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
`;
const FileName = styled(Box).attrs(() => ({
    font: 'metadata-regular-asphalt',
    mt: 6,
    px: 4,
})) `
  word-break: break-all;
`;
//# sourceMappingURL=Preview.js.map